import React from 'react';
function PerformanceOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 4H19.5V20H16.5V4ZM4.5 14H7.5V20H4.5V14ZM13.5 9H10.5V20H13.5V9Z" })));
}
export default PerformanceOutlined;
